/**
 * 積卸地設定ページ用のスクリプト
 */
if (is_route('etc_gate.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        etc_gate_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.etc_gate_event_set = function() {

    let csvSettingModalId = '#etc_gate-csv-setting-modal';
    let csvFormId = csvSettingModalId + '-form';

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + 'csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', csvSettingModalId + '-csv', function () {
        let csvFormId = csvSettingModalId + '-form';
        let action = $(csvFormId).data('confirm-action');
        let datas = new FormData($(csvFormId).get(0));
        $(csvSettingModalId + '-csv-error').addClass('display-none').empty();
        $(csvSettingModalId + '-csv-submit-message').addClass('display-none').empty();
        $("[data-csv-save-modal]").prop('disabled', true);
        // 送信
        _ajax.file(action, datas, function (results) {
            $(csvSettingModalId + '-csv-submit-message').removeClass('display-none');
            $(csvSettingModalId + '-csv-submit-message').text(results.messages[0]);
            $("[data-csv-save-modal]").prop("disabled", false);
        }, function(xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
            $(this).val('');
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(csvSettingModalId + '-csv-error').removeClass('display-none');
                $(csvSettingModalId + '-csv-error').append($('<li></li>').text(message));
            });
        });
    });

    /*---- CSVアップロード時 ----*/

    // 設定表示時
    $(document).on('click', '[data-csv-save-modal]', function () {
        let action = $(csvFormId).attr('action');
        let datas = new FormData($(csvFormId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(csvSettingModalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.omitted(xhr, status, errorThrown);
        });
    });
}
